module.exports = __webpack_public_path__ + "img/empty-top.5e40d40f.png";